import { pillChipActiveSx } from './pillChipActiveSx.js'

/**
 * @param {boolean} active
 * @param {boolean} interactive
 * @param {{ shape?: 'pill', surface?: 'secondary' }} [opts]
 */
export function buildPillChipSx(active, interactive, opts = {}) {
  const shapeSx = opts.shape === 'pill' ? { borderRadius: '9999px' } : {}
  const idleHover = interactive
    ? { bgcolor: 'var(--app-bg-active)', borderColor: 'transparent' }
    : { borderColor: 'transparent' }
  const idle = {
    color: 'var(--app-text-secondary)',
    bgcolor: 'var(--app-bg-hover)',
    border: '1px solid transparent',
    borderColor: 'transparent',
    '&:hover': idleHover,
    '& .MuiChip-icon': { color: 'var(--app-text-secondary)' },
  }

  return {
    flexShrink: 0,
    height: 24,
    maxHeight: 24,
    borderRadius: 'var(--app-radius-md)',
    fontFamily: 'var(--app-font-sans)',
    fontSize: 'var(--app-font-size-sm)',
    fontWeight: 400,
    lineHeight: '20px',
    boxShadow: 'none',
    transition:
      'background-color var(--app-motion-duration-fast) var(--app-motion-ease-standard), border-color var(--app-motion-duration-fast) var(--app-motion-ease-standard)',
    '& .MuiChip-label': { px: 1.25, py: 0, lineHeight: '20px' },
    '& .MuiChip-icon': {
      ml: 0.75,
      mr: -0.25,
      width: 16,
      height: 16,
      fontSize: 16,
      '& > svg': { width: 16, height: 16 },
    },
    '&.Mui-disabled': { opacity: 0.48 },
    ...(active ? pillChipActiveSx(opts.surface) : idle),
    ...shapeSx,
  }
}
